import VersionDisplay from './VersionDisplay';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="border-t bg-card/50 backdrop-blur supports-[backdrop-filter]:bg-card/50">
      <div className="container mx-auto px-4 py-6">
        <div className="text-center space-y-4">
          <div className="space-y-2">
            <p className="text-sm font-semibold text-foreground">
              Church Hub · Engage · Encourage · Evangelize
            </p>
            <p className="text-sm text-muted-foreground">
              © {currentYear} SAFEducation. All rights reserved. Patent Pending.
            </p>
            <p className="text-xs text-muted-foreground">
              Church Hub is a ministry engagement platform developed by SAFEducation.
            </p>
            <p className="text-xs text-muted-foreground">
              FireTEXT® is a registered trademark of FireTEXT Dispatch Solutions, used under license.
            </p>
            <p className="text-xs text-muted-foreground">
              All other trademarks are the property of their respective owners.
            </p>
          </div>
          <div className="flex justify-center items-center space-x-6 text-xs flex-wrap">
            <a href="/privacy" className="text-muted-foreground hover:text-foreground underline">
              Privacy Policy
            </a>
            <a href="/terms" className="text-muted-foreground hover:text-foreground underline">
              Terms of Service
            </a>
            <a href="/contact" className="text-muted-foreground hover:text-foreground underline">
              Contact Us
            </a>
            <a href="/status" className="text-muted-foreground hover:text-foreground underline">
              Status
            </a>
            <VersionDisplay />
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;